import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  HeartIcon,
  CommentIcon,
  ShareIcon,
  BookmarkIcon,
} from '../icons/FeedIcons';

function PostActions({
  isLiked: initialIsLiked,
  isBookmarked: initialIsBookmarked,
  onLike,
  onComment,
  onShare,
  onBookmark,
}) {
  const [isLiked, setIsLiked] = useState(initialIsLiked);
  const [isBookmarked, setIsBookmarked] = useState(initialIsBookmarked);

  const handleLike = () => {
    setIsLiked(!isLiked);
    if (onLike) onLike(!isLiked);
  };

  const handleBookmark = () => {
    setIsBookmarked(!isBookmarked);
    if (onBookmark) onBookmark(!isBookmarked);
  };

  return (
    <div className="flex items-center justify-between px-3 py-2">
      <div className="flex items-center gap-4">
        {/* Like button */}
        <button
          type="button"
          onClick={handleLike}
          className="hover:opacity-60 transition-opacity"
          aria-label={isLiked ? 'Unlike' : 'Like'}
        >
          <HeartIcon
            filled={isLiked}
            className={`w-6 h-6 ${isLiked ? 'text-red-500' : 'text-puzzle-text'}`}
          />
        </button>

        {/* Comment button */}
        <button
          type="button"
          onClick={onComment}
          className="hover:opacity-60 transition-opacity"
          aria-label="Comment"
        >
          <CommentIcon className="w-6 h-6 text-puzzle-text" />
        </button>

        {/* Share button */}
        <button
          type="button"
          onClick={onShare}
          className="hover:opacity-60 transition-opacity"
          aria-label="Share"
        >
          <ShareIcon className="w-6 h-6 text-puzzle-text" />
        </button>
      </div>

      {/* Bookmark button */}
      <button
        type="button"
        onClick={handleBookmark}
        className="hover:opacity-60 transition-opacity"
        aria-label={isBookmarked ? 'Remove bookmark' : 'Bookmark'}
      >
        <BookmarkIcon
          filled={isBookmarked}
          className={`w-6 h-6 ${isBookmarked ? 'text-puzzle-text' : 'text-puzzle-text'}`}
        />
      </button>
    </div>
  );
}

PostActions.propTypes = {
  isLiked: PropTypes.bool,
  isBookmarked: PropTypes.bool,
  onLike: PropTypes.func,
  onComment: PropTypes.func,
  onShare: PropTypes.func,
  onBookmark: PropTypes.func,
};

PostActions.defaultProps = {
  isLiked: false,
  isBookmarked: false,
  onLike: null,
  onComment: null,
  onShare: null,
  onBookmark: null,
};

export default PostActions;
